// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"76312f1df9a50d903f01","293":"075f89fdea24902a5bca","518":"f5a8dc85508bb56f91ba","779":"302d4dc00150f19c8de6"}[chunkId] + ".js";
};